<template>
  <icon-button
    round
    class="fridge-button"
    :class="{ 'on-top': top }"
    :title="$t('bet-slip.scroll-' + (top ? 'down' : 'up'))"
    @click="click"
  >
    <i-arrow :title="$t('bet-slip.scroll-' + (top ? 'down' : 'up'))"></i-arrow>
  </icon-button>
</template>

<script>
import IconButton from '@/components/buttons/IconButton'
import IArrow from 'vue-material-design-icons/AndroidAuto'

export default {
  components: {
    IconButton,
    IArrow
  },
  data () {
    return {
      top: true
    }
  },
  methods: {
    click () {
      this.$emit(this.top ? 'down' : 'up')
      this.top = !this.top
    }
  }
}
</script>

<style scoped>
.fridge-button { color: #2c3e50; margin: 5px; }
.fridge-button > span { font-size: 18px; -webkit-transition: all 0.3s; -moz-transition: all 0.3s; -o-transition: all 0.3s; transition: all 0.3s; }
.fridge-button.on-top > span { -webkit-transform: rotate(180deg); -moz-transform: rotate(180deg); -o-transform: rotate(180deg); transform: rotate(180deg); }
</style>



// WEBPACK FOOTER //
// src/components/buttons/FridgeButton.vue